import { render, staticRenderFns } from "./DownlinkSelector.vue?vue&type=template&id=1a843a82"
import script from "./DownlinkSelector.vue?vue&type=script&lang=js"
export * from "./DownlinkSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports